export default __webpack_public_path__ + "static/media/share_icon.c6f8a36c.svg";